/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PresignUploadRequest
 */
export interface PresignUploadRequest {
    /**
     * 
     */
    contentType?: string;
    /**
     * 
     */
    purpose?: string;
}

/**
 * Check if a given object implements the PresignUploadRequest interface.
 */
export function instanceOfPresignUploadRequest(value: object): value is PresignUploadRequest {
    return true;
}

export function PresignUploadRequestFromJSON(json: any): PresignUploadRequest {
    return PresignUploadRequestFromJSONTyped(json, false);
}

export function PresignUploadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresignUploadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contentType': json['contentType'] == null ? undefined : json['contentType'],
        'purpose': json['purpose'] == null ? undefined : json['purpose'],
    };
}

export function PresignUploadRequestToJSON(json: any): PresignUploadRequest {
    return PresignUploadRequestToJSONTyped(json, false);
}

export function PresignUploadRequestToJSONTyped(value?: PresignUploadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contentType': value['contentType'],
        'purpose': value['purpose'],
    };
}

